function GuineaBissau({ dimensions, col = '#000' }) {
  const baseXml = `
  <svg width=${dimensions || 24}  height=${dimensions || 24}  viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_521_1307)">
  <path d="M16 0C14.5559 0 13.1569 0.1925 11.8261 0.551188L10.4348 16L11.8261 31.4488C13.1569 31.8075 14.5559 32 16 32C24.8365 32 32 24.8365 32 16C32 7.1635 24.8365 0 16 0Z" fill="#FFDA44"/>
  <path d="M10.4348 16L11.8261 31.4488C13.1569 31.8075 14.5559 32 16 32C24.8365 32 32 24.8365 32 16H10.4348Z" fill="#6DA544"/>
  <path d="M0 15.9999C0 22.0646 3.37438 27.3408 8.34781 30.0544V1.94531C3.37438 4.65894 0 9.93518 0 15.9999Z" fill="#D80027"/>
  <path d="M0 15.9996C0 23.392 5.01381 29.6124 11.8261 31.4484V0.550781C5.01381 2.38678 0 8.60716 0 15.9996Z" fill="#D80027"/>
  <path d="M6.04604 11.8262L7.08197 15.0147H10.4349L7.72248 16.9854L8.75835 20.174L6.04604 18.2034L3.3336 20.174L4.36972 16.9854L1.65735 15.0147H5.01004L6.04604 11.8262Z" fill="black"/>
  </g>
  </svg>
  `;

  return baseXml;
}

export default GuineaBissau;
